// extracted by mini-css-extract-plugin
export default {"translationsTabs":"BudgetGeneralityDefaultScreen_translationsTabs__wmNSW"};